module.exports = __webpack_public_path__ + "static/media/cancel-24px.1725c927.svg";